export default {"src":"/_next/static/media/gb.6c5e14c1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};